import { ThemeColor } from '@savgroup-front-common/types';

/**
 * Single source of truth mapping a styled-components `theme.colors.*` key to its
 * `--brand-*` CSS custom property.
 *
 * This is the pivot of the theming indirection layer: `applyThemeToCSSVariables`
 * writes the seller theme into these variables, while
 * `adapters/adaptCssVariablesToThemeOverride` reads them back into a
 * styled-components compatible override — both stay in sync through this map.
 */
export const BRAND_COLOR_VARIABLE_BY_COLOR_KEY = {
  primary: '--brand-primary',
  secondary: '--brand-secondary',
  success: '--brand-success',
  alert: '--brand-alert',
  danger: '--brand-danger',
  backgroundColor: '--brand-background',
  white: '--brand-surface',
  mainTextColor: '--brand-text',
  paragraphTextColor: '--brand-text-secondary',
  headingTextColor: '--brand-heading',
  default: '--brand-default',
  disabled: '--brand-disabled',
} as const satisfies Partial<Record<keyof ThemeColor, string>>;

export type BrandColorKey = keyof typeof BRAND_COLOR_VARIABLE_BY_COLOR_KEY;
